import { animate, style, transition, trigger } from '@angular/animations';
import { Platform } from '@angular/cdk/platform';
import { Component, ElementRef, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ProductCategory, ProductCollections } from '../../../models/product';
import { ProductApiService } from '../../../services/apis/product-api.service';
import { AuthButton } from '../../auth/auth-button/auth-button';
import { Logo } from '../../common/logo/logo';
import { SiteName } from '../../common/site-name/site-name';
import { ShoppingCartButton } from '../../shopping/shopping-cart-button/shopping-cart-button';
import { MainMenuButton } from '../main-menu-button/main-menu-button';
import { MainToolbarDropdown } from '../main-toolbar-dropdown/main-toolbar-dropdown';
import { SearchButton } from '../search-button/search-button';

@Component({
  selector: 'toolbar[app-main-toolbar]',
  imports: [
    Logo,
    SiteName,
    ShoppingCartButton,
    AuthButton,
    SearchButton,
    RouterModule,
    MainToolbarDropdown,
    MainMenuButton,
  ],
  templateUrl: './main-toolbar.html',
  styleUrl: './main-toolbar.scss',
  animations: [
    trigger('dropdown', [
      transition(':enter', [
        style({ height: 0 }),
        animate('150ms ease-in-out', style({ height: 200 })),
      ]),
      transition(':leave', [
        style({ height: 200 }),
        animate('150ms ease-in-out', style({ height: 0 })),
      ]),
    ]),
  ],
})
export class MainToolbar implements OnInit {
  constructor(
    private productApi: ProductApiService,
    private elRef: ElementRef,
    private platform: Platform
  ) {}

  ngOnInit(): void {
    this.findProductCategories();

    if (this.platform.isBrowser) {
      document.addEventListener('click', (event) => {
        if (!this.elRef.nativeElement.contains(event.target)) {
          this.activeCategory = undefined;
        }
      });
    }
  }

  get bestSellersNo(): string {
    return ProductCollections.BestSellers;
  }

  get newArrivalsNo(): string {
    return ProductCollections.NewArrivals;
  }

  categories: ProductCategory[] = [];
  loading: boolean = false;
  async findProductCategories() {
    try {
      this.loading = true;
      this.categories = await this.productApi.findProductCategories();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  activeCategory?: ProductCategory;
  setActiveCategory(category: ProductCategory) {
    if (this.activeCategory === category) {
      this.activeCategory = undefined;
    } else {
      this.activeCategory = category;
    }
  }
}
